export const SITE_ROUTES = {
  home: "/",
  identity: "/our-identity/",
  mission: "/our-mission/",
  vision: "/our-vision/",
  values: "/our-values/",
  portfolio: "/portfolio/",
  contact: "/contact/",
  privacyPolicy: "/privacy-policy/",
  blog: "/blog/",
  servicesArchive: "/service/",
} as const;

export const PRIMARY_MENU_LINKS = [
  { href: SITE_ROUTES.home, label: "Home", meta: "Overview" },
  { href: SITE_ROUTES.identity, label: "Identity", meta: "Who we are" },
  { href: SITE_ROUTES.mission, label: "Mission", meta: "Our purpose" },
  { href: SITE_ROUTES.servicesArchive, label: "Services", meta: "What we do" },
  { href: SITE_ROUTES.portfolio, label: "Portfolio", meta: "Selected work" },
  { href: SITE_ROUTES.blog, label: "Blog", meta: "Ideas & insights" },
  { href: SITE_ROUTES.contact, label: "Contact", meta: "Start a project" },
] as const;

export const HERO_RAIL_LINKS = [
  { href: SITE_ROUTES.contact, label: "Start a project" },
  { href: SITE_ROUTES.portfolio, label: "Selected work" },
  { href: SITE_ROUTES.servicesArchive, label: "What we do" },
] as const;
